import { render, staticRenderFns } from "./BgVideo.vue?vue&type=template&id=3e12705c"
import script from "./BgVideo.vue?vue&type=script&lang=js"
export * from "./BgVideo.vue?vue&type=script&lang=js"
import style0 from "./BgVideo.vue?vue&type=style&index=0&id=3e12705c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports